<template>
	<div style="width:1400px; height:860px;" v-on:keyup.esc="close()">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="invoice_date_from"/> ~ <CustomDatePicker v-model="invoice_date_to"/></span>
				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="ship_to_code" ph="Ship To" :customerOnly="true" :showName="false" @set-partner="setPartner" /> </span>
				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="bill_to_code" ph="Bill To" :customerOnly="true" :showName="false" @set-partner="setPartner" /> </span>
				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_10"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

				<a href="javascript:;" class="search_bt" @click="boSearch()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="boReset()">Reset</a>
			</div>
		</div>
		<div class="view_inner">
			<div class="fixed-table-container" style="padding-top:0px;">
				<div class="table-wrapper" style="height: 97%">
					<table class="list_tbl sticky_list_tbl">
						<thead>
							<tr>
								<th width="210px;">
									<a href="javascript:;" @click="sort('class_code')">{{ headers.class }} Code{{ sortMark('class_code') }}</a>
								</th>
								<th>{{ headers.class }} Name</th>
								<th width="200px;">Color</th>
								<th width="80px;">
									<a href="javascript:;" @click="sort('bo_quantity')">Back Qty.{{ sortMark('bo_quantity') }}</a>
								</th>
								<th width="80px;">
									<a href="javascript:;" @click="sort('on_hand')">On-Hand{{ sortMark('on_hand') }}</a>
								</th>
								<th width="50px;"><input type="checkbox" @change="selectBoAll()" v-model="boAllSelected" /></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in bo_items" v-bind:key="item.invoice_item_no">
								<td class="al_left">{{ item.class_code }}</td>
								<td class="al_left truncate">{{ item.class_name }}</td>
								<td class="al_left">{{ item.color_code }}</td>
								<td class="al_right">
									<font color="red">{{ item.bo_quantity | commaSeparated }}</font>
								</td>
								<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
								<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}, (Max {{ page_size }})</div>

			<div class="view_bottom_bt" style="padding-top:20px;">
				<a href="javascript:;" type="button" class="search_bt" @click="adjustInventory()">Adjust Inventory to 0</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="boClose()">Close</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
//import { apiSelectPartnerList } from '@/api/partner/index.js';
import { apiInvoiceIndex, apiSelectBackOrderItemSumList } from '@/api/sales/invoice.js';
import { apiAdjustBatch } from '@/api/item/inventory.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import { daysAgo, today } from '@/utils/date.js';

export default {
	data: function() {
		return {
			backUri: '/',
			paging_yn: 'N',
			page_size: 500,
			page_no: 1,
			list_count: 0,

			sort_key: 'class_code',
			sort_direction: 'ASC',

			invoice_date_from: daysAgo(7),
			invoice_date_to: today(),
			ship_to_code: null,
			bill_to_code: null,
			sales_group_code: null,

			salesGroups: [],

			boAllSelected: false,
			bo_items: [],
		};
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		CodeSelect,
		PartnerSelect,
	},
	methods: {
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectBackOrderItemsSum();
			//console.log(sort_key);
		},
		async adjustInventory() {
			var item_data = [];

			this.bo_items.forEach(function(item) {
				if (item.selected) {
					var param_item = {
						item_id: item.item_id,
						before_quantity: item.on_hand,
						after_quantity: 0,
					};

					if (!param_item.before_quantity) param_item.before_quantity = 0;
					if (!param_item.after_quantity) param_item.after_quantity = 0;

					item_data.push(param_item);
				}
			});

			if (item_data.length == 0) {
				this.$toast.error('Nothing to adjust');
				return;
			}

			if (!confirm(item_data.length + ' item(s) will be adjusted to 0. Are you sure to proceed?')) return;

			var param = {
				adjust_reason: 'adjust',
				items: item_data,
			};
			//console.log(param);
			const { data } = await apiAdjustBatch(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.selectBackOrderItemsSum();
			} else {
				this.$toast.error(data.msg);
			}
		},
		setPartner() {
			this.boSearch();
		},
		selectBoAll() {
			var vm = this;
			this.bo_items.forEach(function(item) {
				item.selected = vm.boAllSelected;
			});
		},
		boReset() {
			this.invoice_date_from = daysAgo(7);
			this.invoice_date_to = today();

			this.sales_group_code = null;
			this.ship_to_code = null;
			this.bill_to_code = null;
		},
		boSearch() {
			this.selectBackOrderItemsSum();
		},
		async selectBackOrderItemsSum() {
			var param = {
				paging_yn: 'N',
				page_size: 500,

				invoice_date_from: this.invoice_date_from,
				invoice_date_to: this.invoice_date_to,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,

				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
			};

			const { data } = await apiSelectBackOrderItemSumList(param);

			this.bo_items = data.itemList;
			this.list_count = this.bo_items.length;
			//console.log(this.bo_items);
		},

		async index() {
			const { data } = await apiInvoiceIndex();
			this.salesGroups = data.salesGroupList;
		},

		async init() {
			await this.index();
			this.boSearch();
		},

		boClose() {
			this.$emit('close');
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
